import React, { useEffect, useState } from "react";
import { Button, Col, Row, Table, Form, Container } from "react-bootstrap";
import trasportApi from "../../api/trasportApi";
import { ShimmerTable } from "react-shimmer-effects";
import Main from "../layout/Main";
import AdvanceDieselChallanEdit from "./TripAdvanceDieselChallanEdit";
import Confirm from "../Confirm";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import { Link, Navigate } from "react-router-dom";
import InfoPill from "../InfoPill";
import Helmet from "react-helmet";
import { LIST_TAB_TITLE } from "../../constants/CONSTANT";
import Select from "react-select";

// React Icons Starts Here
import { FiEdit } from "react-icons/fi";
import { FaTrashAlt } from "react-icons/fa";
import { BsChevronRight } from "react-icons/bs";
import moment from "moment";
//React Icons Ends here.

const SubjectList = () => {
  const [body, setBody] = useState([]);
  const [modalShow, setModalShow] = React.useState(false);
  const [vechileRec, setBranch] = React.useState({});
  const [modalShowEditBranch, setModalShowEditBranch] = React.useState(false);
  const [financialYearOption, setOptionFinancialYear] = useState([]); // Initialize as an array
  const [tempBody, setTempBody] = useState([]);
  const [selectedFinancialYear, setSelectedFinancialYear] = useState({});
  const [supplierOption, setOptionSupplier] = useState([]);
  const [selectedSupplier, setSelectedSupplier] = useState({});
  const [itemOption, setOptionChallan] = useState([]);
  const [selectedChallan, setselectedChallan] = useState({});
  const [branchOption, setOptionBranch] = useState([]);
  const [selectedbranch, setSelectedBranch] = useState({});
  const [clientOption, setOptionClient] = useState([]);
  const [selectedClient, setSelectedClient] = useState({});
  const [vechicleOption, setOptionVechicle] = useState([]);
  const [selectedVechicle, setSelectedVechicle] = useState({});
  const [challanData, setChallanData] = useState({
    from_challan_date: moment().format("YYYY-MM-DD"),
    to_challan_date: moment().format("YYYY-MM-DD"),
  });

  useEffect(() => {
    fetchAllBranches();
    fetchData();
  }, []);

  const fetchData = async () => {
    const fnYear = await trasportApi.fetchAllActiveFinancialYears();
    const challanRec = await trasportApi.fetchAllChallan();
    const branchRec = await trasportApi.fetchAllBranch();
    const vechicleRec = await trasportApi.fetchAllVehicles();

    if (fnYear && fnYear.length) {
      let ar = [];
      fnYear.forEach((item) => {
        ar.push({ value: item.id, label: item.name });
      });

      const currentMonth = new Date().getMonth() + 1; // getMonth() is zero-based
      const currentYear = new Date().getFullYear();
      let defaultOption;

      if (currentMonth >= 3) {
        // March is the 3rd month
        defaultOption = ar.find(
          (option) => option.label === `${currentYear}-${currentYear + 1}`
        );
      } else {
        defaultOption = ar.find(
          (option) => option.label === `${currentYear - 1}-${currentYear}`
        );
      }

      if (defaultOption) {
        setSelectedFinancialYear(defaultOption);
        setChallanData({
          ...challanData,
          financial_year_id: defaultOption.value,
        });
      }
      setOptionFinancialYear(ar);
    } else {
      setOptionFinancialYear([]);
    }

    //Challan Api Setup
    if (challanRec && challanRec.length) {
      //eslint-disable-next-line
      let challanOption = challanRec.map((item) => ({
        value: item.id,
        label: item.challan_no,
        branch_name: item.branch_name,
        client_name: item.client_name,
        vehicle_number: item.vehicle_number,
        financial_year_name: item.financial_year_name,
        challan_date: item.challan_date,
        client_id: item.client_id,
      }));
      setOptionChallan(challanOption);
    } else {
      setOptionChallan([]);
    }
    //Branch Api Data.

    //Vechile Api Data.
    if (vechicleRec && vechicleRec.length) {
      let ar = [];
      vechicleRec.forEach((item) => {
        ar.push({ value: item.id, label: item.vehicle_number });
      });
      setOptionVechicle(ar);
    } else {
      setOptionVechicle([]);
    }
  };

  const fetchAllBranches = () => {
    async function init() {
      const branch = await trasportApi.fetchAllAdvanceDieselChallan();
      if (branch) {
        setBody(branch);
        setTempBody(branch);
      } else {
        setBody([]);
      }
    }
    init();
  };

  useEffect(() => {
    const fetchData = async () => {
      const fnYear = await trasportApi.fetchAllFinancialYears();
      if (fnYear && fnYear.length) {
        let ar = [];
        fnYear.forEach((item) => {
          ar.push({ value: item.id, label: item.name });
        });
        setOptionFinancialYear(ar);
      } else {
        setOptionFinancialYear([]);
      }
    };

    fetchData();
  }, []);

  console.log("objec22t",body);

  // Create table headers consisting of 4 columns.
  const header = [
    {
      title: "Challan Diesel Date",
      prop: "challan_diesel_advance_date",
      isSortable: true,
      isFilterable: true,
      cell: (row) => (
        <span>
          {row.challan_diesel_advance_date
            ? moment(row.challan_diesel_advance_date).format("DD MMM, yyyy")
            : ""}
        </span>
      ),
    },
    { title: "Supplier Name", prop: "supplier_name", isFilterable: true },
    { title: "Qty", prop: "qty", isFilterable: true },
    { title: "Rate (Price)", prop: "rate", isFilterable: true },

    {
      title: "Diesel Challan Amount",
      prop: "total_amount",
      isFilterable: true,
    },
    // { title: "Pan Number", prop: "pan_number", isFilterable: true },
    // { title: "Engine Number", prop: "engine_number", isFilterable: true },
    // { title: "Chasis Number", prop: "chasis_number", isFilterable: true },
    
    { title: "Remark", prop: "remark", isFilterable: true },
    {
      title: "Financial Year",
      prop: "financial_year_name",
      isFilterable: true,
    },
    { title: "Created By", prop: "createdbyname", isFilterable: true },
    {
      title: "Lastmodified By",
      prop: "lastmodifiedbyname",
      isFilterable: true,
    },
  ];

  header.push({
    title: "Actions",
    prop: "id",
    cell: (row) => (
      <div>
        <Button
          className="btn-sm mx-1"
          onClick={() => editFinancialYearList(row)}
        >
          <FiEdit />
        </Button>
        <Button
          variant="danger"
          className="btn-sm mx-1"
          onClick={() => handleDelete(row)}
        >
          <FaTrashAlt />
        </Button>
      </div>
    ),
  });

  // Randomize data of the table columns.
  // Note that the fields are all using the `prop` field of the headers.
  const labels = {
    beforeSelect: " ",
  };

  const createBranch = () => {
    setBranch({});
    setModalShowEditBranch(true);
    // navigate(`/advancechallans/e`);
  };

  const submitFinancialYearList = () => {
    // setModalShowCreateDoctorDuty(false);
    // setModalShowEditBranch(false);
    // fetchAllDuties();
    // setDoctorDuty({});
  };

  const editFinancialYearList = (row) => {
    setModalShowEditBranch(true);
    setBranch(row);
  };

  const handleDelete = (row) => {
    console.log(row);
    setModalShow(true);
    setBranch(row);
  };
  const isdelete = async () => {
    const result = await trasportApi.deleteAdvanceChallan(vechileRec.id);
    if (result.success) {
      setBranch("");
      setModalShow(false);
      fetchAllBranches();
    }
  };
  const onFilterTypeYear = async (event) => {
    var arr = [];
    tempBody.forEach((item) => {
      if (item.financial_year_name === event.target.value) {
        arr.push(item);
      } else {
        arr.push();
      }
    });
    setBody(arr.length > 0 ? arr : tempBody);
  };

  //Item
  const handleItem = (e) => {
    setselectedChallan(e);
    setChallanData({ ...challanData, challan_id: e.value });
  };

  //Client
  const handleClient = (e) => {
    setSelectedClient(e);
    setChallanData({ ...challanData, client_id: e.value });
  };

  //Branch
  const handleBranch = (e) => {
    setSelectedBranch(e);
    setChallanData({ ...challanData, branch_id: e.value });
  };

  //Vehicle
  const handleVechile = async (e) => {
    console.log("event", e);
    let vechicleId = e;
    console.log("object", vechicleId);
    if (vechicleId) {
      setChallanData({ ...challanData, vehicle_id: vechicleId.value });
      const challanRecData = await trasportApi.fetchChallanByVehicleId(
        vechicleId?.value
      );
      if (challanRecData && challanRecData.length) {
        //eslint-disable-next-line
        let challanOption = challanRecData.map((item) => ({
          value: item.id,
          label: item.challan_no,
          branch_name: item.branch_name,
          client_name: item.client_name,
          vehicle_number: item.vehicle_number,
          financial_year_name: item.financial_year_name,
          challan_date: item.challan_date,
          client_id: item.client_id,
        }));
        setOptionChallan(challanOption);
        setSelectedVechicle(vechicleId);
      } else {
        setOptionChallan([]);
      }
    }
  };
  const handleChange = (e) => {
    setChallanData({ ...challanData, [e.target.name]: e.target.value });
  };
  const handleSearch = async (e) => {
    console.log("Search",challanData);
    const result = await trasportApi.fetchAllFilterAdvanceChallan(challanData);
    console.log("result", result);
    setBody(result);
  };

  const handleClear = () => {
    setChallanData({
      from_challan_date: "",
      to_challan_date: "", 
      branch_id: "", 
      vehicle_id: "",
      client_id: "",
      financial_year_id: "",
      challan_number: "",
    });
    window.location.reload();
  };

  return (
    <Main>
      <>
        <Helmet>
          <title>Diesel Challan List</title>
        </Helmet>
      </>

      {modalShowEditBranch && (
        <AdvanceDieselChallanEdit
          show={modalShowEditBranch}
          onHide={() => setModalShowEditBranch(false)}
          submitFinancialYearList={submitFinancialYearList}
          vechileRec={vechileRec ? vechileRec : {}}
        />
      )}

      {modalShow && (
        <Confirm
          show={modalShow}
          onHide={() => setModalShow(false)}
          isdelete={isdelete}
          title="Confirm delete?"
          message="You are going to delete the record. Are you sure?"
          table="Vehicle"
        />
      )}

      <Row className="g-0">
        <Col lg={2} className="mx-2">
          <Link to="/home" style={{ "text-decoration": "none" }}>
            Home
          </Link>
          {/* <i className="fa-solid fa-chevron-right"></i>  */}
          <BsChevronRight />
          Advance Challan List
        </Col>
        <Row
          style={{ border: "2px solid #000000", padding: "10px" }}
          className="mx-1"
        >
          <p
            style={{
              fontSize: "22px",
              display: "flex",
              justifyContent: "center",
              fontWeight: "bold",
            }}
          >
            Search Diesel Challan Details
          </p>
          <Col lg={2}>
            <Form.Group className="mt-2" controlId="formBasicCourses">
              <Form.Label
                className="form-view-label"
                htmlFor="formBasicAdmissiondate"
              >
                Select Financial Year
              </Form.Label>
              <Form.Select
                aria-label="Enter Financial Year"
                name="financial_year_name"
                onChange={onFilterTypeYear}
              >
                <option value="">--Select Financial Year--</option>
                <option value="">All</option>
                {financialYearOption.map((option) => (
                  <option key={option.value} value={option.label}>
                    {option.label}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
          <Col lg={2}>
            <Form.Group className="mt-2" controlId="formBasicCourses">
              <Form.Label
                className="form-view-label"
                htmlFor="formBasicAdmissiondate"
              >
                Select Vehicle No
              </Form.Label>
              <Select
                placeholder="Select Vehicle Name"
                value={selectedVechicle}
                onChange={handleVechile}
                options={vechicleOption}
              ></Select>
              <Form.Control.Feedback type="invalid">
                Please Select Vehicle Name.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col lg={2}>
            <Form.Group className="mt-2" controlId="formBasicCourses">
              <Form.Label
                className="form-view-label"
                htmlFor="formBasicAdmissiondate"
              >
                Challan No
              </Form.Label>
              <Select
                placeholder="Select Item Name"
                value={selectedChallan}
                onChange={handleItem}
                options={itemOption}
              ></Select>
              <Form.Control.Feedback type="invalid">
                Please Select Item Name.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col lg={2}>
            <Form.Group className="" controlId="formBasicCourses">
              <Form.Label
                className="form-view-label"
                htmlFor="formBasicAdmissiondate"
              >
                From Advance Challan Date
              </Form.Label>
              <Form.Control
                type="date"
                name="from_challan_date"
                value={challanData.from_challan_date}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
          <Col lg={2}>
            <Form.Group className="" controlId="formBasicCourses">
              <Form.Label
                className="form-view-label"
                htmlFor="formBasicAdmissiondate"
              >
                To Advance Challan Date
              </Form.Label>
              <Form.Control
                type="date"
                name="to_challan_date"
                value={challanData.to_challan_date}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>

          <Col lg={2}>
            <Form.Group className="mx-3 mt-2">
              <Form.Label className="form-view-label">
                Party/Client Name
              </Form.Label>
              <Form.Control
                disabled
                placeholder="Client Name"
                value={selectedChallan.client_name}
                // onChange={handleVechile }
                style={{ height: "38px" }}
              />
              <Form.Control.Feedback type="invalid">
                Please Enter Party/Client Name.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col lg={2}>
            <Form.Group className="mx-3">
              <Form.Label className="form-view-label">
                Challan Branch Name
              </Form.Label>
              <Form.Control
                disabled
                placeholder="Branch Name"
                value={selectedChallan.branch_name}
                // onChange={handleVechile }
                style={{ height: "38px" }}
              />
              <Form.Control.Feedback type="invalid">
                Please Enter Challan Branch Name.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col lg={2}>
            <Form.Group className="mx-3">
              <Form.Label className="form-view-label">
                Challan Vehicle Number
              </Form.Label>
              <Form.Control
                disabled
                placeholder="Vehicle Number"
                value={selectedChallan.vehicle_number}
                // onChange={handleVechile }
                style={{ height: "38px" }}
              />
              <Form.Control.Feedback type="invalid">
                Please Enter Vehicle Number.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>

          <Col lg={2}>
            <Button variant="success" className="mt-5" onClick={handleSearch}>
              Search
            </Button>
            <Button
              variant="secondary"
              className="mt-5 mx-3"
              onClick={handleClear}
            >
              Clear
            </Button>
          </Col>
        </Row>
        <Col lg={12} className="p-lg-4">
          {body ? (
            <DatatableWrapper
              body={body}
              headers={header}
              paginationOptionsProps={{
                initialState: {
                  rowsPerPage: 10,
                  options: [5, 10, 15, 20],
                },
              }}
            >
              <Row className="mb-4">
                <Col
                  xs={12}
                  lg={4}
                  className="d-flex flex-col justify-content-end align-items-end"
                >
                  <Filter />
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  lg={4}
                  className="d-flex flex-col justify-content-start align-items-center"
                >
                  <PaginationOptions
                    labels={labels}
                    style={{ marginLeft: "14px" }}
                  />
                  <div style={{ position: "absolute", marginLeft: "55px" }}>
                    <InfoPill left="Total" right={body?.length} />
                  </div>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  lg={4}
                  className="d-flex flex-col justify-content-end align-items-end"
                >
                  <Button
                    className="btn-md"
                    variant="primary"
                    onClick={() => createBranch(true)}
                  >
                    New Diesel Challan (Trip)
                  </Button>
                </Col>
              </Row>

              <Table striped className="data-table">
                <TableHeader />

                <TableBody />
              </Table>

              <Pagination />
            </DatatableWrapper>
          ) : (
            <Container>
                 <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
                >
                <span
                    style={{
                    color: "red",
                    fontWeight: "bold",
                    fontSize: "18px",
                    }}
                >
                    😔 No Data Found
                </span>
                </div>
                <ShimmerTable row={10} col={8} />
            </Container>
          )}
        </Col>
        <Col lg={2}></Col>
      </Row>
    </Main>
  );
};
export default SubjectList;
